import axios from "axios";
axios.defaults.withCredentials = true;

const rawApiUrl = String(process.env.REACT_APP_API_URL || "").trim();
export const API_URL = "https://flowsalonsg.com/api";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      if (window.location.pathname !== '/') {
        const BASENAME = process.env.REACT_APP_BASENAME || "";
        window.location.href = `${BASENAME}/`;
      }
    }
    return Promise.reject(error);
  }
);

export const getContacts = async () => {
  let res = await axios.get(
    `${API_URL}/getmessages`
  );
  return res.data;
};

export const getmessagesbynumber = async (phone, limit = 50, page = 1) => {
  var phoneNumber = phone;
  let res = await axios.get(
    `${API_URL}/getmessagesbynumber?number=${phoneNumber}&limit=${limit}&page=${page}`
  );
  return res.data;
};

export const sendmessage = async (userData) => {
  let {
    wa_number,
    message_from,
    message_id,
    message_timestamp,
    wa_type,
    message_body,
    contact_name,
  } = userData;
  let res = await axios.get(
    `${API_URL}/sendmessage?wa_number=${wa_number}&message_from=${message_from}&message_id=${message_id}&message_timestamp=${message_timestamp}&wa_type=${wa_type}&message_body=${message_body}&contact_name=${contact_name}`
  );
  return res.data;
};

export const loginForm = async (userData) => {
  let data = JSON.stringify(userData);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/islogin`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
    })
    .catch((error) => {
    });
};

export const saveTemplates = async (userData) => {
  let res = await axios.post(
    `${API_URL}/templates`,
    userData
  );
  let json = res.data;
  return json;
};

export const sendtemplate = async (userData) => {
  let res = await axios.post(
    `${API_URL}/sendtemplate`,
    userData
  );
  let json = res.data;
  return json;
};

export const gettemplates = async () => {
  let res = await axios.get(
    `${API_URL}/gettemplates`
  );
  return res.data;
};

export const deleteTemplate = async (userData) => {
  let res = await axios.post(
    `${API_URL}/deletetemplate`,
    userData
  );
  return res.data;
};

export const getServices = async () => {
  let res = await axios.get(`${API_URL}/services`);
  return res.data;
};

export const saveService = async (serviceData) => {
  let res = await axios.post(`${API_URL}/services`, serviceData);
  return res.data;
};

export const saveServiceOptions = async (serviceId, options) => {
  let res = await axios.post(`${API_URL}/services/${serviceId}/options`, options);
  return res.data;
};

export const updateService = async (serviceData) => {
  let res = await axios.patch(`${API_URL}/services`, serviceData);
  return res.data;
};

export const deleteService = async (serviceId) => {
  let res = await axios.post(`${API_URL}/deleteservice`, { id: serviceId });
  return res.data;
};

export const getTherapists = async () => {
  let res = await axios.get(`${API_URL}/therapists`);
  return res.data;
};

export const saveTherapist = async (therapistData) => {
  let res = await axios.post(`${API_URL}/therapists`, therapistData);
  return res.data;
};

export const updateTherapist = async (therapistData) => {
  let res = await axios.patch(`${API_URL}/therapists`, therapistData);
  return res.data;
};

export const deleteTherapist = async (therapistId) => {
  let res = await axios.post(`${API_URL}/deletetherapist`, { id: therapistId });
  return res.data;
};

export const getAppointments = async () => {
  let res = await axios.get(`${API_URL}/appointments`);
  return res.data;
};

export const updateAppointment = async (appointmentData) => {
  let res = await axios.patch(`${API_URL}/appointments`, appointmentData);
  return res.data;
};

export const deleteAppointment = async (appointmentId) => {
  let res = await axios.post(`${API_URL}/deleteappointment`, { id: appointmentId });
  return res.data;
};

export const changePassword = async (data) => {
  return await axios.post(
    `${API_URL}/changepassword`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const logoutUser = async () => {
  let res = await axios.post(`${API_URL}/logout`);
  return res.data;
};

export const sendmedia = async (formData) => {
  let res = await axios.post(
    `${API_URL}/sendmedia`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return res.data;
};

export const getContactDetails = async (wa_number) => {
  let res = await axios.get(`${API_URL}/contact?wa_number=${wa_number}`);
  return res.data;
};

export const updateContactDetails = async (data) => {
  let res = await axios.post(`${API_URL}/contact/update`, data);
  return res.data;
};

export const getUserSettings = async () => {
  let res = await axios.get(`${API_URL}/settings`);
  return res.data;
};

export const updateUserSettings = async (settings) => {
  let res = await axios.post(`${API_URL}/settings`, settings);
  return res.data;
};

export const handleGoogleCallback = async (code) => {
  try {
    const response = await axios.post(`${API_URL}/calendar/callback`, { code }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    return response.data;
  } catch (error) {
    console.error("Error handling google callback:", error);
    return { success: false, error: error.message };
  }
};

export const getCalendarStatus = async () => {
  let res = await axios.get(`${API_URL}/calendar/status`);
  return res.data;
};

export const disconnectCalendar = async () => {
  let res = await axios.post(`${API_URL}/calendar/disconnect`);
  return res.data;
};

export const getAvailability = async () => {
  let res = await axios.get(`${API_URL}/calendar/availability`);
  return res.data;
};

export const setAvailability = async (data) => {
  let res = await axios.post(`${API_URL}/calendar/availability`, data);
  return res.data;
};

export const getAvailableDates = async (therapistId, duration, excludeEventId) => {
  let url = `${API_URL}/calendar/available-dates`;
  const params = [];
  if (therapistId) params.push(`therapist_id=${therapistId}`);
  if (duration) params.push(`duration=${duration}`);
  if (excludeEventId) params.push(`exclude_event_id=${excludeEventId}`);
  if (params.length > 0) url += `?${params.join('&')}`;

  let res = await axios.get(url);
  return res.data;
};

export const getSlots = async (date, therapistId, excludeEventId, duration) => {
  let url = `${API_URL}/calendar/slots?date=${date}&therapist_id=${therapistId}`;
  if (excludeEventId) url += `&exclude_event_id=${excludeEventId}`;
  if (duration) url += `&duration=${duration}`;
  let res = await axios.get(url);
  return res.data;
};

export const deleteContact = async (wa_number) => {
  let res = await axios.post(`${API_URL}/deletecontact`, { wa_number });
  return res.data;
};

export const reorderServices = async (orders) => {
  let res = await axios.post(`${API_URL}/services/reorder`, { orders });
  return res.data;
};

export const getBundles = async () => {
  let res = await axios.get(`${API_URL}/services/bundles`);
  return res.data;
};

export const saveBundle = async (bundleData) => {
  let res = await axios.post(`${API_URL}/services/bundles`, bundleData);
  return res.data;
};

export const updateBundle = async (bundleData) => {
  let res = await axios.put(`${API_URL}/services/bundles`, bundleData);
  return res.data;
};

export const reorderBundles = async (orders) => {
  let res = await axios.post(`${API_URL}/services/bundles/reorder`, { orders });
  return res.data;
};

export const deleteBundle = async (bundleId) => {
  let res = await axios.delete(`${API_URL}/services/bundles/${bundleId}`);
  return res.data;
};
